module.exports = __webpack_public_path__ + "static/media/donna.756e2dbc.png";